module.exports = __webpack_public_path__ + "img/icone-pergunta.6148ec90.png";